module.exports = __webpack_public_path__ + "./fonts/logo-no-bg.7718b3e3ff59dac728c55e725a3b0523.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-chat-window/es/assets/logo-no-bg.svg
// module id = ./node_modules/react-chat-window/es/assets/logo-no-bg.svg
// module chunks = 0